<template>
    <div class="sub-product-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="sub-product d-flex justify-content-between">
                        <div class="sub-product-item text-center mt-30">
                            <router-link :to="{path: '/categories/' + categories[3].id + '/' + categories[3].name}">
                                <img v-lazy="categories[3].filePath" :alt="categories[3].name"><br>
                                <a href="product-details.html"><span>{{categories[3].name}}</span></a>
                            </router-link>
                        </div> <!-- sub product item -->
                        <div class="sub-product-item text-center mt-60">
                            <router-link :to="{path: '/categories/' + categories[2].id + '/' + categories[2].name}">
                                <img v-lazy="categories[2].filePath" :alt="categories[2].name"><br>
                                <a href="product-details.html"><span>{{categories[2].name}}</span></a>
                            </router-link>
                        </div> <!-- sub product item -->
                        <div class="sub-product-item text-center mt-30">
                            <router-link :to="{path: '/categories/' + categories[4].id + '/' + categories[4].name}">
                                <img v-lazy="categories[4].filePath" :alt="categories[4].name"><br>
                                <a href="product-details.html"><span>{{categories[4].name}}</span></a>
                            </router-link>
                        </div> <!-- sub product item -->
                        <div class="sub-product-item text-center mt-60">
                            <router-link :to="{path: '/categories/' + categories[1].id + '/' + categories[1].name}">
                                <img v-lazy="categories[1].filePath" :alt="categories[1].name"><br>
                                <a href="product-details.html"><span>{{categories[1].name}}</span></a>
                            </router-link>
                        </div> <!-- sub product item -->
                        <div class="sub-product-item text-center mt-30">
                            <router-link :to="{path: '/categories/' + categories[0].id + '/' + categories[0].name}">
                                <img v-lazy="categories[0].filePath" :alt="categories[0].name"><br>
                                <a href="product-details.html"><span>{{categories[0].name}}</span></a>
                            </router-link>
                        </div> <!-- sub product item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- container -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Featured",
        data() {
            return {
                categories: []
            }
        },
        methods: {
            getFeaturedCategories() {
                this.axios.get('featured-category').then((data) => {
                    this.categories = data.data
                })
            }
        },
        created() {
            this.getFeaturedCategories();
        }
    }
</script>

<style scoped>

</style>